/**
 * De kop boven elk scherm: het logo, de naam van wie is ingelogd, de
 * uitlogknop, en de tabbladen als het scherm die heeft.
 *
 * Stond drie keer in de code, en de stijlen van kop en tabbladen waren in
 * het leerkracht- en het beheerscherm letterlijk gelijk. `extra` is voor
 * knoppen die één scherm naast de uitlogknop wil, zoals "Gelezen teksten"
 * bij de leerling.
 */
import React from 'react';
import { LogOut } from 'lucide-react';

export function Kop({ naam, onLogout, tabs, actief, kiesTab, extra, compact = false }) {
  return (
    <div style={{ ...stijl.kop, ...(compact ? stijl.plakkend : {}) }}>
      <div style={{ ...stijl.balk, ...(compact ? stijl.balkCompact : {}) }}>
        <img src="/Anna_Maria.png" alt="Anna Maria" style={{ height: compact ? 80 : 112 }} />
        <div style={stijl.rechts}>
          <span style={compact ? { fontWeight: 500 } : undefined}>{naam}</span>
          {extra}
          <button className="btn btn-danger" onClick={onLogout} style={compact ? { padding: '8px 16px' } : undefined}>
            <LogOut size={16} /> Uitloggen
          </button>
        </div>
      </div>

      {tabs && (
        <div style={stijl.tabs}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{ ...stijl.tab, ...(actief === tab.id ? stijl.tabActief : {}) }}
              onClick={() => kiesTab(tab.id)}
            >
              <tab.icon size={16} />
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const stijl = {
  kop: { background: 'var(--wit)', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' },
  plakkend: { position: 'sticky', top: 0, zIndex: 100 },
  balk: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px' },
  balkCompact: { padding: '12px 24px', maxWidth: 1400, margin: '0 auto' },
  rechts: { display: 'flex', alignItems: 'center', gap: '16px' },
  // negen tabbladen bij Beheer (stap 29): op een smal scherm een tweede rij, niet van het scherm af
  tabs: { display: 'flex', flexWrap: 'wrap', gap: '4px', padding: '0 24px', borderBottom: '1px solid var(--lijn)', background: 'var(--wit)' },
  // Alle randen apart, zodat de actieve tab alleen de onderrand verandert
  // (React waarschuwt als `border` en `borderBottom` door elkaar gaan).
  tab: {
    padding: '16px 20px', borderTop: 'none', borderLeft: 'none', borderRight: 'none',
    borderBottom: '3px solid transparent', marginBottom: '-1px', background: 'none', cursor: 'pointer',
    fontSize: '15px', color: 'var(--stil)', display: 'flex', alignItems: 'center', gap: '8px',
  },
  tabActief: { color: 'var(--inkt)', borderBottom: '3px solid var(--accent)', fontWeight: 'bold' },
};
